/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';

import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import { HtmlOutput } from 'components/atoms/HtmlOutput';
import { EMPTY_VALUES } from 'constants/general';
import { FIELDS } from 'features/common/SingleNote/form';
import { equalOrThreeDashes } from 'utils';
import { joinString } from 'utils/string';

export const SingleNote = ({
	item,
	supportHtml = false,
	noteContentLabel = getLabelMessage('singleNote:noteContent'),
}) => {
	const fullName = joinString(' ', [item?.userCreatedSurname, item?.userCreatedFirstName]);

	return (
		<Grid size={12}>
			<Grid container spacing={2}>
				<Grid size={3}>
					<OutputTextField
						size="small"
						fieldName={FIELDS.noteFullName}
						label={getLabelMessage('singleNote:noteFullName')}
						fullWidth
						value={fullName}
						slotProps={{
							input: {
								readOnly: true,
								disableUnderline: true,
							},

							inputLabel: {
								shrink: !!fullName,
							},
						}}
						variant="standard"
					/>
				</Grid>
				<Grid size={3}>
					<OutputTextField
						size="small"
						fieldName={FIELDS.noteDateCreated}
						label={getLabelMessage('singleNote:noteDateCreated')}
						fullWidth
						value={
							item?.dateCreated ? format(new Date(item?.dateCreated), 'dd.MM.yyyy') : EMPTY_VALUES.STRING
						}
						slotProps={{
							input: {
								readOnly: true,
								disableUnderline: true,
							},
							inputLabel: {
								shrink: !!item?.dateCreated,
							},
						}}
						variant="standard"
					/>
				</Grid>
				<Grid size={12}>
					{supportHtml ? (
						<Stack spacing={1}>
							<Typography
								color="grey.600"
								sx={{
									fontSize: 12,
								}}
							>
								{noteContentLabel}
							</Typography>
							<Stack
								sx={(theme) => ({
									borderRadius: '4px',
									border: `1px solid ${theme.palette.grey[500]}`,
									px: '14px',
									py: '8px',
									fontSize: '1rem',
								})}
							>
								<HtmlOutput content={equalOrThreeDashes(item?.comment)} />
							</Stack>
						</Stack>
					) : (
						<OutputTextField
							size="small"
							fieldName={FIELDS.noteContent}
							label={getLabelMessage('singleNote:noteContent')}
							fullWidth
							multiline
							value={equalOrThreeDashes(item?.comment)}
							slotProps={{
								inputLabel: {
									shrink: !!equalOrThreeDashes(item?.comment),
								},
							}}
						/>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

SingleNote.propTypes = {
	item: PropTypes.object,
	noteContentLabel: PropTypes.string,
	supportHtml: PropTypes.bool,
};

export default SingleNote;
